import { render, staticRenderFns } from "./cCookies.vue?vue&type=template&id=1ae867f4&scoped=true"
import script from "./cCookies.vue?vue&type=script&lang=js"
export * from "./cCookies.vue?vue&type=script&lang=js"
import style0 from "./cCookies.vue?vue&type=style&index=0&id=1ae867f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae867f4",
  null
  
)

export default component.exports